// F7: per-institution e-mail templates (EmailTemplateDtos on the server).

export type EmailTemplateKey =
  | 'INVOICE' | 'INVOICE_PAY_LINK' | 'QUOTATION' | 'CREDIT_NOTE' | 'STATEMENT' | 'SHIPMENT' | 'REMITTANCE';

/** A key's effective template; customised false = the built-in text. fields = the {{field}} whitelist. */
export interface EmailTemplate {
  key: EmailTemplateKey;
  label: string;
  subject: string;
  body: string;
  customised: boolean;
  fields: string[];
  defaultSubject: string;
  defaultBody: string;
}

export interface SaveEmailTemplateRequest {
  subject: string;
  body: string;
}

/** Rendered with sample values; nothing is sent. htmlBody is escaped server-side. */
export interface RenderedEmail {
  subject: string;
  plainBody: string;
  htmlBody: string;
}

export const EMAIL_SUBJECT_MAX = 200;
export const EMAIL_BODY_MAX = 10000;

/** Placeholders written in the text that are not in the key's whitelist (the server refuses them with a 400). */
export const unknownPlaceholders = (text: string, fields: string[]): string[] => {
  const found = new Set<string>();
  const re = /\{\{([\s\S]*?)\}\}/g; // same as the server's PLACEHOLDER, name trimmed
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    const name = m[1].trim();
    if (!fields.includes(name)) found.add(name);
  }
  return Array.from(found);
};

/** Review M1: the pay-link mail must carry {{pay.url}} (subject or body); mirrors EmailTemplateService.validate. */
export const missingRequiredField = (key: EmailTemplateKey, subject: string, body: string): string | null => {
  if (key !== 'INVOICE_PAY_LINK') return null;
  const has = (t: string) => /\{\{\s*pay\.url\s*\}\}/.test(t);
  return has(subject) || has(body) ? null : 'pay.url';
};
